import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import { mediumUp } from 'constants/mediaQueries';
import Theme from 'styles/theme';

export const PLACEMENTS = {
  BOTTOM: 'BOTTOM',
  TOP: 'TOP',
};

const ProductBadge = ({ badgeText, placement }) => {
  return (
    <span
      className={classNames('ProductBadge', {
        'ProductBadge--bottom': placement === PLACEMENTS.BOTTOM,
        'ProductBadge--top': placement === PLACEMENTS.TOP,
      })}
    >
      {badgeText}
      <style jsx>{`
        .ProductBadge {
          display: block;
          position: absolute;
          max-width: 90%;
          background-color: ${Theme.get('colors-white-semi-transparent')};
          border-radius: ${Theme.get('border-radius-px')};
          border-bottom-right-radius: 0;
          border-top-right-radius: 0;
          color: ${Theme.get('colors-black')};
          font-style: italic;
          font-weight: ${Theme.get('font-weight-bold')};
          font-size: ${Theme.get('font-size-small') - 1}px;
          letter-spacing: 1px;
          text-transform: uppercase;
          font-family: ${Theme.get('font-family')};
          animation: fadeIn ${Theme.get('transition-duration')}ms
            ${Theme.get('transition-timing-ease-in-out-sine')};
        }

        .ProductBadge--bottom {
          left: ${Theme.get('spacing') * 3}px;
          bottom: ${Theme.get('spacing') * 2.5}px;
          padding: ${Theme.get('spacing')}px ${Theme.get('spacing') * 1.5}px;
        }

        .ProductBadge--top {
          left: ${Theme.get('spacing') * 4}px;
          top: ${Theme.get('spacing') * 4}px;
          padding: ${Theme.get('spacing') * 1.5}px;
        }

        @media ${mediumUp} {
          .ProductBadge {
            max-width: 80%;
            letter-spacing: 2px;
            font-size: ${Theme.get('font-size-small-px')};
            padding: ${Theme.get('spacing') * 1.5}px ${Theme.get('spacing') * 2}px;
          }

          .ProductBadge--bottom {
            left: ${Theme.get('spacing') * 3}px;
            bottom: ${Theme.get('spacing') * 3}px;
          }

          .ProductBadge--top {
            left: ${Theme.get('spacing') * 5}px;
            top: ${Theme.get('spacing') * 5}px;
          }
        }
      `}</style>
    </span>
  );
};

ProductBadge.propTypes = {
  badgeText: PropTypes.string.isRequired,
  placement: PropTypes.string.isRequired,
};

export default ProductBadge;
